import { RawTeamMember, TeamMember } from '../model/TeamMember';

export const localizeMember = (raw: RawTeamMember, lang: 'cs' | 'en'): TeamMember => {
  return {
    photo: raw.photo,
    name: raw.name[lang],
    positions: raw.positions[lang],
  };
};
